import { render, staticRenderFns } from "./EditProfileDialog.vue?vue&type=template&id=047ab2c9&scoped=true&"
import script from "./EditProfileDialog.vue?vue&type=script&lang=js&"
export * from "./EditProfileDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileDialog.vue?vue&type=style&index=0&id=047ab2c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ab2c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VDialog,VIcon,VOverlay})
